// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xy_h","label":"styles_label__2N6b5"};